/* eslint-disable camelcase */

import type { BaseArchiveResult, DashboardApiArchiveShapeBase } from "@dashboardApi/apis";

export type EngagementInAppMessageColorProfilesUpdateArchivedStateResult =
  | EngagementInAppMessageColorProfilesUpdateArchivedStateErrorResult
  | EngagementInAppMessageColorProfilesUpdateArchivedStateSuccessResult;

export const isErrorResult = (
  result: EngagementInAppMessageColorProfilesUpdateArchivedStateResult
): result is EngagementInAppMessageColorProfilesUpdateArchivedStateErrorResult => {
  return (result as EngagementInAppMessageColorProfilesUpdateArchivedStateErrorResult).warn !== undefined;
};

export interface EngagementInAppMessageColorProfilesUpdateArchivedStateSuccessResult extends BaseArchiveResult {
  info: string;
  undo_identifier: number;
  undo_data: {
    ids: string[];
    reenable: string[];
    mark_as_archived: boolean;
  };
}

export interface EngagementInAppMessageColorProfilesUpdateArchivedStateErrorResult {
  warn: string;
}

export interface PostEngagementInAppMessageTemplateUpdateArchivedStateProps extends DashboardApiArchiveShapeBase {
  ids: string[];
}
